import { Trans, useTranslation } from "react-i18next";

import { Checkbox, Link } from "@aviary";
import { sharedRoutes } from "@shared/data/sharedRoutes";
import { useSharedGlobalConfig } from "@shared/hooks";
import { l } from "@unauthenticated/shared/locales/i18n";

interface Props {
  updateTimestamp: (date: Date | "") => void;
  isChecked: boolean;
}

const TermsOfServiceCheckbox = ({ updateTimestamp, isChecked }: Props) => {
  const { isEmerson } = useSharedGlobalConfig();
  const { t } = useTranslation();

  const platform = isEmerson ? t(l.common.EmersonEcologics) : t(l.common.Fullscript);
  const route = isEmerson ? sharedRoutes.external.emersonTerms : sharedRoutes.external;

  const handleCheckboxChange = e => {
    if (e.target.checked) {
      const date = new Date();
      updateTimestamp(date);
    } else {
      updateTimestamp("");
    }
  };

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (!e.target.checked) {
        const date = new Date();
        updateTimestamp(date);
      } else {
        updateTimestamp("");
      }
    }
  };

  return (
    <Checkbox
      data-e2e="tos_checkbox"
      onChange={handleCheckboxChange}
      onKeyDown={handleKeyDown}
      defaultChecked={isChecked}
      key={isChecked.toString()}
    >
      <Trans i18nKey={l.common.Terms}>
        I agree to {{ platform }}'s
        <Link href={route.termsOfService} noExternalIcon>
          Terms of Service
        </Link>
        and
        <Link href={route.privacyPolicy} noExternalIcon>
          Privacy Statement
        </Link>
      </Trans>
    </Checkbox>
  );
};

export { TermsOfServiceCheckbox };
